export function environmentPath(workspaceId: number): { environment_id: string } {
  return { environment_id: String(workspaceId) };
}

export function exportPath(workspaceId: number, exportId: string): { environment_id: string; id: string } {
  return { ...environmentPath(workspaceId), id: exportId };
}
